import * as React from 'react'

type Props = {
  width?: string
  height?: string
}

const FiltersIcon: React.FunctionComponent<Props> = (props) => {
  const { width, height } = props
  return (
    <svg
      width={width ? width : '23'}
      height={height ? height : '18'}
      viewBox="0 0 21 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0605 8C18.2696 8 20.0605 6.2091 20.0605 4C20.0605 1.79086 18.2696 0 16.0605 0C14.1967 0 12.6306 1.27477 12.1865 3H1.06055C0.508267 3 0.0605469 3.44772 0.0605469 4C0.0605469 4.55229 0.508267 5 1.06055 5H12.1865C12.6306 6.7252 14.1967 8 16.0605 8ZM14.0605 4C14.0605 5.10457 14.9559 6 16.0605 6C17.1651 6 18.0605 5.10457 18.0605 4C18.0605 2.89543 17.1651 2 16.0605 2C14.9559 2 14.0605 2.89543 14.0605 4ZM0.0605469 12C0.0605469 9.7909 1.85141 8 4.06055 8C5.92439 8 7.49049 9.2748 7.93453 11H19.0605C19.6128 11 20.0605 11.4477 20.0605 12C20.0605 12.5523 19.6128 13 19.0605 13H7.93453C7.49049 14.7252 5.92439 16 4.06055 16C1.85141 16 0.0605469 14.2091 0.0605469 12ZM6.06055 12C6.06055 10.8954 5.16512 10 4.06055 10C2.95598 10 2.06055 10.8954 2.06055 12C2.06055 13.1046 2.95598 14 4.06055 14C5.16512 14 6.06055 13.1046 6.06055 12Z"
        fill="#1A1E3D"
      />
    </svg>
  )
}

export default FiltersIcon
